import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StrapiService {

  public strapUrl = environment.strapiUrl;
  public JWTToken = environment.strapiJWTToken;

  constructor(
    private _http: HttpClient
  ) { }

  // helper: build headers with JWT
  private authHeaders(): HttpHeaders {
    let headers = new HttpHeaders;
    headers = headers.set('Authorization', this.JWTToken);
    return headers;
  }

  // helper: turn a plain object into HttpParams
  private toHttpParams(obj?: Record<string, string | number | boolean>): HttpParams {
    let params = new HttpParams();
    if (!obj) return params;
    Object.entries(obj).forEach(([k, v]) => {
      if (v !== undefined && v !== null) params = params.set(k, String(v));
    });
    return params;
  }

  /**
    * Get Auth Screen details
  */
  public getAuthScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/sign-up-screen-image?populate[image][fields][1]=url&populate[logo][fields][1]=url`);
  }

  /**
    * Get T&C Screen details
  */
  public getTermsAndConditionsScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/terms-and-conditions?populate=*`);
  }

  /**
    * Get T&C Screen details
  */
  public getTermsAndConditionsCategories(): Observable<object> {

    // returns all terms and conditions categories
    return this._http.get(`${this.strapUrl}/terms-and-conditions-categories?populate=*`);
  }


  /**
    * Get Privacy Policy Screen details
  */
  public getPrivacyPolicyScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/terms-and-conditions?populate=*`);
  }


  /**
    * Get Contact us Screen details
  */
  public getContactUsScreenContent(): Observable<object> 
  {
    // replace Agility JWT with Strap JWT
    return this._http.get(`${this.strapUrl}/contact-us-page?fields[0]=text&populate[image][fields][1]=url&populate[headerImage][fields][1]=url&populate[mobileImage][fields][2]=url`);
  }

  /**
    * Get Complaints Screen details
  */
  public getComplaintsScreenContent(): Observable<object> 
  {
    // replace Agility JWT with Strap JWT
    return this._http.get(`${this.strapUrl}/complaints-page-header?populate[image][fields][1]=url&populate[mobileImage][fields][2]=url&populate[terms_and_conditions]=*&populate[pdf]=*`);
  }

  /**
    * Get Contact us Screen details
  */
  public getAboutUsScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/about-us-pages?populate[image][fields][1]=url&populate[image][fields][2]=alternativeText`);
  }

  /**
    * Get Contact us Screen details
  */
  public getAboutUsHeaderContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/about-us-page-header?populate[image][fields][1]=url&populate[mobileImage][fields][2]=url`);
  }

  /**
    * Get Home Page Header Content
  */
  public getHomeHeaderContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-header?fields[0]=headerText&populate[image][fields][1]=url&fields[1]=bodyText&fields[2]=text_color_hex&populate[mobileImage][fields][3]=url`);
  }

  /**
    * Get Home Page Body Content
  */
  public getHomeBodyContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-body?populate=*`);
    // return this._http.get(`${this.strapUrl}/home-page-body?fields[0]=banner_body&fields[1]=banner_header&fields[2]=learn_more_title&fields[3]=learn_more_text&fields[4]=text_color_hex`);
  }

  /**
  * Get Home Faq Body Content
  */
  public getFaqsByCategory(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/faqs?&populate=*`);
  }


  /**
  * Get Support Page Header
  */
  public getSupportPageHeader(): Observable<object> 
  {
    // replace Agility JWT with Strap JWT
    let headers = new HttpHeaders;
    headers = headers.set('Authorization', this.JWTToken);

    // returns body
    return this._http.get(`${this.strapUrl}/support-page-header?populate=*`, {headers});
  }

  /**
  * Get Support Body Content
  */
  public getSupportPageScreenContent(): Observable<object> {

    // return this._http.get(`${this.strapUrl}/supports?populate=*`);
    return this._http.get(`${this.strapUrl}/supports?fields[0]=topic&fields[1]=renderPriority&populate[icon][fields][1]=url&populate[support_category][fields][0]=categoryTitle`);
  }

  /**
  * Get Support Body Content
  */
  public getSupportPageScreenContentById(id): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/supports/${id}?populate=*`);
  }



  /**
  * Get Home Faq Body Content
  */
  public getHelpPageHeaderContent(): Observable<object>
  {
    // replace Agility JWT with Strap JWT
    let headers = new HttpHeaders;
    headers = headers.set('Authorization', this.JWTToken);

    // returns body
    return this._http.get(`${this.strapUrl}/help-page-header?&populate=*`, {headers});
  }


  /**
  * Get Home Faq Body Content
  */
  public getProductsFaqsByCategory(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/faqs?filters[FaqCategory][Title][$eq]=Products`);
  }

  /**
  * Get Home Faq Body Content
  */
  public getRouters(): Observable<object> {

    // replace Agility JWT with Strap JWT
    let headers = new HttpHeaders;
    headers = headers.set('Authorization', this.JWTToken);

    // returns body
    return this._http.get(`${this.strapUrl}/routers?&populate=*`, {headers});
  }



  /**
  * Get Home Faq Body Content
  */
  public getHelpPageScreenContent(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/helps`);
  }

  /**
  * Get Catalog Screen Content
  */
  public getCatalogScreenContent() {

    // returns catalog
    return this._http.get(`${this.strapUrl}/catalog-page-contents?populate[image][fields][1]=url&populate[image][fields][2]=alternativeText`);
  }

  /**
  * Get Catalog Screen Header Content
  */
  public getCatalogScreenHeaderContent() {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/catalog-page-header?populate[image][fields][1]=url&populate[mobileImage][fields][2]=url`);
  }


  /**
  * Get Deals Screen Header Content
  */
  public getDealsScreenHeaderContent() {
  
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/deals-page-header?populate[image][fields][1]=url`);
  }



  /**
  * Get Catalog Screen Content
  */
  public getPartnerLogos() {

    // returns catalog
    return this._http.get(`${this.strapUrl}/partner-logo?populate[logos][fields][1]=url&populate[logos][fields][2]=alternativeText`);
  }

  /**
  * Get Product Faq Body Content
  */
  public GetProductsContent(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/products?populate[headerImage][fields][1]=url&populate[fallbackImage][fields][2]=url&populate[mobileImage][fields][3]=url`);
  }

  /**
  * Get Provinces
  */
  public GetProvinces(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/provinces?populate=*`);
  }

  /**
    * Get Packages Screen details
  */
  public getPackagesScreenContent() 
  {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/service-types`);
  }

  /**
    * Get Packages Screen details
  */
  public getNetworkStatus() 
  {
      // replace Agility JWT with Strap JWT
      let headers = new HttpHeaders;
      headers = headers.set('Authorization', this.JWTToken);
      return this._http.get(`${this.strapUrl}/network-statuses?populate[Provider][populate][logo][fields][0]=url&populate[Province][populate]=*&populate[Product][populate][logo][fields][0]=url&populate[Impact][populate]=*&populate[Type][populate]=*&populate[Status][populate]=*`,{headers});
  }

  /**
  * Get Blogs
  */
public getBlogs(
  paramsOrId?: Record<string, string | number | boolean> | string | number,
  maybeId?: string | number
) {
  // auth header
  const headers = this.authHeaders();

  // Support both styles: getBlogs(id) OR getBlogs(queryObj) / getBlogs(queryObj, id)
  let id: string | number | undefined;
  let paramsObj: Record<string, string | number | boolean> | undefined;

  if (typeof paramsOrId === 'object' && paramsOrId !== null) {
    paramsObj = paramsOrId;
    id = maybeId;
  } else if (typeof paramsOrId === 'string' || typeof paramsOrId === 'number') {
    id = paramsOrId;
  }

  // start with any caller-supplied params
  let params = this.toHttpParams(paramsObj);

  // ensure we always populate the fields used by the blog UI (unless caller specified populate themselves)
  const hasPopulate = params.keys().some(k => k.startsWith('populate'));
  if (!hasPopulate) {
    params = params
      // relations/components 
      .set('populate[0]', 'image')
      .set('populate[1]', 'cover')
      .set('populate[2]', 'author')
      .set('populate[3]', 'category')
      .set('populate[4]', 'coverImage')
      // (limit media fields to url only for smaller payloads
      .set('populate[image][fields][0]', 'url')
      .set('populate[cover][fields][0]', 'url')
      .set('populate[coverImage][fields][0]', 'url')
      // ✅ NEW: include SEO and its nested media
      .set('populate[seo][populate][metaImage][fields][0]', 'url')
      .set('populate[seo][fields][0]', 'metaTitle')
      .set('populate[seo][fields][1]', 'metaDescription')
      .set('populate[seo][fields][2]', 'keywords')
      .set('populate[seo][fields][3]', 'canonicalURL');
  }

  // filter by id when provided
  if (id !== undefined && id !== null) {
    params = params.set('filters[id][$eq]', String(id));
  }

  const url = `${this.strapUrl}/blogs`;
  return this._http.get(url, { headers, params });
}




  /**
    * Get Home Page Header Content
  */
  public getHomePageReasons(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-reasons?populate[icon][fields][1]=url&populate[icon][fields][2]=alternativeText`);
  }


  public getHomePageBanners(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-banners?populate[banner][fields][1]=url&populate[mobileBanner][fields][2]=alternativeText&populate[mobileBanner][fields][3]=url`);
  }


  public getDealImages(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/deal-card-images?populate=*&pagination[limit]=200`);
  }

  public getDealPageBanners(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/deal-page-banners?populate=*`);
  }

  public getDealPageProductBannerFibre(): Observable<object> {
    // returns deal image for fibre
    return this._http.get(`${this.strapUrl}/deal-page-product-banner-fibres?populate=*`);
  }

  public getDealPageProductBannerHWI(): Observable<object> {
    // returns deal image for home wireless internet
    return this._http.get(`${this.strapUrl}/deal-page-product-banner-hwis?populate=*`);
  }

  public getCampaign(): Observable<object> {
      return this._http.get(`${this.strapUrl}/campaign-page?populate=*`);
  }
  
  public getHelpPageTopic(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/help-page-topics?populate[Icon]=*&populate[help_page_sub_topics][populate][help_page_sub_topic_lists][populate][seo]=*`);
  }

  public getHelpPageSubTopicList(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/help-page-sub-topic-lists?&pagination[pageSize]=500&populate=*`);
  }
  

  public getPackageToolTips(): Observable<object> {
    // returns package tool tips
    return this._http.get(`${this.strapUrl}/tooltip-categories?populate=*`);
  }
}
